import React from 'react';
import PropTypes from 'prop-types';
import DropdownMenu from 'common/components/dropdown-menu';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import './index.scss';

const downloadUrlBase = '/analytics/0/export/';

export default class CardConfig extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    customOptions: PropTypes.array,
    dataManagerUrl: PropTypes.string,
    disableConfig: PropTypes.bool,
    disableDownload: PropTypes.bool,
    disableDownloadCsv: PropTypes.bool,
    disableDownloadPointsCsv: PropTypes.bool,
    reportId: PropTypes.number,
    scheduleId: PropTypes.number,
    style: PropTypes.object,
  };

  static defaultProps = {
    disableConfig: false,
    disableDownload: false,
    disableDownloadCsv: false,
    disableDownloadPointsCsv: false,
  };

  getClassName() {
    const classList = ['CardConfig'];
    if (this.props.className) {
      classList.push(this.props.className);
    }
    return classList.join(' ');
  }

  canEditCards() {
    // FIXME reference to window
    return this.props.reportId && window.settings.dashboard.canEditCards;
  }

  render() {
    const {disableDownload, customOptions} = this.props;

    if (!this.props.reportId || this.props.disableConfig) {
      return null;
    }
    // const scheduleText = this.props.scheduleId ? t('Edit email schedule') : t('Email this Card');
    const downloadUrl = downloadUrlBase.replace(
      '/0/',
      `/${this.props.reportId}/`,
    );
    const downloadUrlPdf = `${downloadUrl}pdf`;
    const downloadUrlImage = `${downloadUrl}png`;
    const downloadUrlCsv = `${downloadUrl}csv`;
    const downloadUrlPointsCsv = `${downloadUrl}points_csv`;

    // FIXME reference to window
    const isAdmin = window.settings && window.settings.user.isAdmin;
    const canEdit = this.canEditCards();
    // const canEmail = window.canEmailCards;
    return (
      <DropdownMenu
        arrowStyle={this.props.style}
        className={this.getClassName()}>
        {/*
          Disabling email link for now, will probably email whole dashboads only

          canEmail ? (
          <li key={0}>
            <a
              className={'emailDelivery'}
              data-report-id={this.props.reportId}
              data-schedule-id={this.props.scheduleId}
              href={'#'}>
              {scheduleText}
            </a>
          </li>
        ) : null*/}

        {canEdit
          ? [
              <li key={'edit_card'}>
                <a
                  className={'cardConfigModal'}
                  data-obj_id={this.props.reportId}
                  href={'#'}>
                  <SvgSymbol name={'edit'} />
                  {t('Edit card')}
                </a>
              </li>,
              <li key={'duplicate_card'}>
                <a
                  className={'duplicateReport'}
                  data-obj_id={this.props.reportId}
                  href={'#'}>
                  <SvgSymbol name={'duplicate'} />
                  {t('Duplicate card')}
                </a>
              </li>,
              <li key={'copy_card_to'}>
                <a
                  className={'copyCardTo'}
                  data-obj_id={this.props.reportId}
                  href={'#'}>
                  <SvgSymbol name={'duplicate'} />
                  {t('Copy to...')}
                </a>
              </li>,
              <li className={'DropdownMenuItem--separator'} key={'separator_1'}>
                <hr />
              </li>,
            ]
          : null}

        {!customOptions
          ? null
          : [
              ...customOptions.map((option, index) => (
                <li key={`card-config-custom-option-${index}`}>{option}</li>
              )),
              this.props.dataManagerUrl ? null : (
                <li
                  className={'DropdownMenuItem--separator'}
                  key={'separator_2'}>
                  <hr />
                </li>
              ),
            ]}

        {this.props.dataManagerUrl
          ? [
              <li key={'data_manager'}>
                <a
                  href={this.props.dataManagerUrl}
                  rel='noreferrer'
                  target={'_blank'}>
                  <SvgSymbol name={'export'} />
                  {t('Open in Data Manager')}
                </a>
              </li>,
              <li className={'DropdownMenuItem--separator'} key={'separator_3'}>
                <hr />
              </li>,
            ]
          : null}

        {disableDownload
          ? null
          : [
              isAdmin ? (
                <li key={'share_card'}>
                  <a
                    className={'shareReport'}
                    data-report_id={this.props.reportId}
                    href={'#'}>
                    <SvgSymbol name={'link'} />
                    {t('Share card')}
                  </a>
                </li>
              ) : null,
              <li key={'download_image'}>
                <a className={'downloadImage'} href={downloadUrlImage}>
                  <SvgSymbol name={'download-image'} />
                  {t('Download image')}
                </a>
              </li>,
              <li key={'download_pdf'}>
                <a className={'downloadPdf'} href={downloadUrlPdf}>
                  <SvgSymbol name={'download-pdf'} />
                  {t('Download PDF')}
                </a>
              </li>,
              this.props.disableDownloadCsv ? null : (
                <li key={'download_csv'}>
                  <a
                    className={'downloadCsv'}
                    data-report_id={this.props.reportId}
                    href={downloadUrlCsv}>
                    <SvgSymbol name={'download-csv'} />
                    {t('Download CSV')}
                  </a>
                </li>
              ),
              this.props.disableDownloadPointsCsv ? null : (
                <li key={'download_points_csv'}>
                  <a
                    className={'downloadCsv'}
                    data-report_id={this.props.reportId}
                    href={downloadUrlPointsCsv}>
                    <SvgSymbol name={'download-csv'} />
                    {t('Download points CSV')}
                  </a>
                </li>
              ),
            ]}
        {canEdit
          ? [
              disableDownload ? null : (
                <li
                  className={'DropdownMenuItem--separator'}
                  key={'separator_4'}>
                  <hr />
                </li>
              ),
              <li key={'delete_card'}>
                <a
                  className={'deleteReport'}
                  data-report_id={this.props.reportId}
                  href={'#'}>
                  <SvgSymbol name={'delete'} />
                  {t('Delete card')}
                </a>
              </li>,
            ]
          : null}
      </DropdownMenu>
    );
  }
}
